import { Icon } from '@/components'
import { useArcade } from '@/features/arcade/provider'
import { useArcadeSeasonEnds } from '@/features/arcade/hooks/countdown'

export const SeasonEnds = () => {
  const { season } = useArcade()
  const { seasonEnds } = useArcadeSeasonEnds({ season, precision: 'medium' })

  return (
    <section className="mx-1 mb-[4px] body-sm">
      <div className="flex items-center text-gray-300">
        <div className="max-h-[18px] overflow-hidden">{season?.name} Ends</div>
        <div className="ml-auto text-white flex gap-[4px] items-center ">
          <Icon name="timer" className="w-2 h-2" />
          <div className="max-h-[18px] overflow-hidden">
            {seasonEnds?.formatted}
          </div>
        </div>
      </div>
    </section>
  )
}
